<script>
export default {
  components: {},
  props: {
    text: {
      type: String,
      required: true,
      default: null,
    },
    placeholderTxt: {
      type: String,
      required: false,
      default: '',
    },
    mode: {
      type: String,
      required: false,
      default: null,
    },
    color: {
      type: String,
      required: false,
      default: null,
    },
    enableAutoExpand: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      editing: false,
      initialText: '',
      textareaHeight: null,
    };
  },
  computed: {},
  mounted() {
    this.initialText = this.text;

    if (this.enableAutoExpand) {
      this.init();
      document.addEventListener('input', this.listenerFunction, false);
    }
  },
  destroyed() {
    document.removeEventListener('input', this.listenerFunction, false);
  },
  methods: {
    init() {
      if (this.$refs.inlineEditInput) {
        const parentWidth = document.getElementById('textareaWidth').clientWidth;
        const childWidth = document.getElementsByClassName('widthIndecator')[0].getBoundingClientRect().width;
        if (typeof childWidth === 'number' && typeof parentWidth === 'number') {
          this.textareaHeight =
            childWidth < parentWidth ? this.$refs.inlineEditInput.scrollHeight - 28 : this.$refs.inlineEditInput.scrollHeight;
        }
      }
    },
    listenerFunction(event) {
      if (event.target.tagName.toLowerCase() !== 'textarea') return;
      const field = event.target;
      const parentWidth = document.getElementsByClassName('content')[0].clientWidth;
      const childWidth = document.getElementsByClassName('widthIndecator')[0].getBoundingClientRect().width;
      // Reset field height
      field.style.height = 'inherit';
      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);
      // Calculate the height
      const height =
        parseInt(computed.getPropertyValue('border-top-width'), 10) +
        parseInt(computed.getPropertyValue('padding-top'), 10) +
        field.scrollHeight +
        parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        parseInt(computed.getPropertyValue('border-bottom-width'), 10);
      if (typeof childWidth === 'number' && typeof parentWidth === 'number' && childWidth < parentWidth) {
        field.style.height = height - 28 + 'px';
      } else {
        field.style.height = height + 'px';
      }
    },
    toggleEdit() {
      this.editing = true;
      setTimeout(() => this.$refs.inlineEditInput.focus());
    },
    validate(evt) {
      if (evt.target.value === '') {
        this.editing = false;
        this.text = this.initialText;
      }
    },
  },
};
</script>

<template>
  <span ref="inlineEditInputParent" class="inlineEditInputParent">
    <span class="inline-text" v-show="!editing && mode !== 'edit'" @click="toggleEdit">
      {{ text }}
    </span>
    <textarea
      v-show="editing || mode === 'edit'"
      :style="`height: ${textareaHeight}px;`"
      :class="['input-inline-edit', { lightTxt: color }]"
      type="text"
      ref="inlineEditInput"
      :value="text"
      :placeholder="placeholderTxt"
      @input="$emit('update-editable-value', $event.target.value)"
      @keydown.enter="editing = false"
      @blur="validate"
    />
    <span class="widthIndecator">{{ text }}</span>
  </span>
</template>

<style lang="scss" scoped>
@import '@design';

.widthIndecator {
  visibility: hidden;
  white-space: nowrap;
}
.input-inline-edit {
  background: transparent;
  border: 0;
  border-bottom: 1px solid $color-border-light-gray;
  display: inline-block;
  font-size: 4.8rem;
  font-weight: 900;
  letter-spacing: -0.761905px;
  line-height: 5.5rem;
  margin-top: 1rem;
  padding: 0;
  transition: border-bottom $duration-animation-base ease-in-out;
  width: 100%;
  &:focus {
    border-bottom: 1px solid $color-border-light-gray;
    outline: none;
  }

  &.lightTxt {
    color: $color-off-white;
  }
}
</style>
